/**
 * Counts API requests in flight, so one progress bar (GlobalProgress) can show
 * whenever any screen is loading or saving.
 */
type Listener = (pending: number) => void;

let pending = 0;
const listeners = new Set<Listener>();

const emit = () => listeners.forEach((listener) => listener(pending));

/** Calls `listener` with the number of requests in flight now and on every change. */
export function subscribeLoading(listener: Listener): () => void {
  listeners.add(listener);
  listener(pending);
  return () => {
    listeners.delete(listener);
  };
}

/** Counts `promise` as loading until it settles; returns it unchanged. */
export function trackLoading<T>(promise: Promise<T>): Promise<T> {
  pending += 1;
  emit();
  const done = () => {
    pending -= 1;
    emit();
  };
  promise.then(done, done);
  return promise;
}
